export const partnerReleases = {
  certifyAndOpen: "Certify and enable an approved scope",
  certificationDetails: "Access evidence ({count})",

  feedTitle: "Read-only Tingee certification on an active connection",
  feedHint: "Read the real API and compare the same transaction across webhook, polling, normalization and delivery to Shop. Passing issues a 7-day certificate for webhook and transaction polling; it does not open access or certify new bank linking.",
  feedLoad: "Load Live connections",
  feedConnection: "Connection",
  feedChoose: "Choose a connection to verify",
  feedRun: "Verify read-only and certify",
  feedRunning: "Verifying…",
  feedPassed: "Certificate issued",
  feedFailed: "Verification failed",
  keepExisting: "Keep currently enabled capabilities when attaching this certificate",

  manualTitle: "Open manually without certification",
  manualHint: "Allow the selected scope without a passed test profile. Records the approver and reason; does not create test evidence.",
  manualChoose: "Choose app, provider and environment",
  manualMarket: "Market",
  manualCapabilities: "Released capabilities",
  manualUntil: "Expires at (empty = no expiry)",
  manualAcknowledge: "I approve this scope without test certification.",
  manualOpen: "Approve manually and open",
  manualLabel: "Manually approved — uncertified",

  stale: "Configuration/adapter changed",
  closedCatalog: "Catalog without a release",
  noRelease: "Not released; run certification or approve manually",
  enforce: "Enforce policy",
  enforceHint: "The consumer must acknowledge the current shadow version first. Cutover makes legacy switches read-only; providers and environments without valid certification remain closed.",
  confirmClosed: "I reviewed the shadow snapshot and confirm uncertified providers and environments stay closed.",
  shadowNotice: "Some apps remain in shadow: policy is delivered for comparison while existing authority stays active. Each app needs the matching version/hash/mode ACK and a separate cutover approval.",
  title: "Partner and environment releases",
  intro: "Open with test certification or an explicit manual approval for the selected app, provider, environment and scope.",
  reload: "Reload",
  loading: "Loading releases…",
  ownerApp: "Owning app",
  partner: "Partner",
  environment: "Environment",
  status: "Status",
  scopeCertification: "Scope / approval basis",
  revision: "Revision",
  actions: "Actions",
  enabled: "Open",
  disabled: "Closed",
  expired: "Expired",
  revoked: "Revoked",
  valid: "Valid",
  noScope: "No scope declared",
  empty: "No releases yet. Partners and environments remain closed by default.",
  close: "Close",
  revoke: "Revoke",
  closeReason: "Temporarily closed by HQ",
  revokePrompt: "Certification revocation reason (required):",
  revokeReasonInput: "Enter a reason for revocation",
  reasonRequired: "Enter a certification revocation reason.",
  cancel: "Cancel",
  revokeCode: "HQ_OPERATOR_REVOKED",
  retry: "Reload",
  profileEvidence:'Completed profile evidence',chooseEvidence:'Select an issue and readback pair',noEvidence:'No complete evidence for the same document/version',
  validUntil:'Certification expires at',certify:'Issue certification',certifyHint:'Certification requires every profile step with the same fixture, document, version and current adapter. Issuing a certificate does not open the service.',
  certification:'Valid certification / manual approval',chooseCertificate:'Select a current certification',noValidCertificate:'No current certification',openReason:'Release reason',open:'Open the certified scope',
} as const;
